import RoundedButtonLinkPrimary from '../../components/button/rounded-button-link-primary/RoundedButtonLinkPrimary';
import Image from '../../components/image/Image';
import styles from './subproject-reminder.module.less';

const SubprojectReminder = ({ projectId, className = '', disabled }) => {
    return (
        <div className={[styles.subprojectReminderContainer, className].join(' ')}>
            <div className={styles.subprojectReminder}>
                <p className={styles.inviteParticipantsText}>Husk å invitere deltakere for å skape engasjement!</p>
                <div className={styles.inviteParticipantsButton}>
                    <RoundedButtonLinkPrimary
                        category={'participant-banner-invite'}
                        action={'click'}
                        className={disabled ? styles.disabled : ''}
                        properties={{ projectId }}
                        to={`/project/${projectId}/control/subprojects`}
                    >
                        Inviter deltakere
                    </RoundedButtonLinkPrimary>
                </div>
                <Image
                    className={styles.inviteParticipantsImage}
                    src="product/dugnad-inviter.svg"
                    alt="Deltakere som blir invitert"
                />
            </div>
        </div>
    );
};

export default SubprojectReminder;
